module.exports = __webpack_public_path__ + "img/Boat.f3d57549.png";